import { render, staticRenderFns } from "./TitleSlot.vue?vue&type=template&id=80339394&"
import script from "./TitleSlot.vue?vue&type=script&lang=js&"
export * from "./TitleSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports